/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

import { useAppState } from "hooks/AppContext";
import { useFeatureFlagsState } from "hooks/FeatureFlagsContext";
import { ArticleHeader } from "./ArticleHeader";
import { LeadMediaModule } from "./LeadMediaModule";
import { ArticleSocial } from "./ArticleSocial";
import { ArticleContent } from "./ArticleContent";
import { SponsorModule } from "./SponsorModule";
import { EmailCapture } from "./EmailCapture";
import { RecentArticles } from "./RecentArticles";

import styles from "./articleContainer.module.scss";

export const ArticleContainer = () => {
    const { article } = useAppState();
    const {
        articleContentModules,
        articleUri,
        blockHeadingPrefix,
        breadcrumbLinks,
        contentAuthor,
        leadMedia,
        listBuilder,
        listicleContentType,
        postListBodyContent,
        product,
        slug,
        sponsor,
        tags,
        templateName,
        title,
        componentProps,
        dateUpdated,
        postDate,
        primaryTopic
    } = article;

    const social = {
        articleUri,
        slug,
        title,
        writerName: contentAuthor?.writerName,
        writerSlug: contentAuthor?.writerSlug,
        twitterHandle: contentAuthor?.twitterHandle,
        dateUpdated: (postDate > dateUpdated) ? postDate : dateUpdated
    };

    const author = {
        articleUri,
        slug,
        title,
        ...contentAuthor
    };

    const sponsorModuleProps = {
        listicleContentType,
        tags,
        product,
        ...sponsor,
        componentProps
    };

    const articleContentProps = {
        articleContentModules,
        postListBodyContent,
        blockHeadingPrefix,
        listBuilder,
        templateName,
        sponsorModuleProps: { ...sponsorModuleProps },
        author,
        dateUpdated,
        postDate
    };

    const { FEATURE_FLAG_NEWSLETTER_MODAL } = useFeatureFlagsState();

    return (
        <article className={styles.article}>
            <div className={styles.articleContainer}>
                <ArticleHeader articleTitle={title} breadcrumbs={breadcrumbLinks} />
                <div className={styles.articleBannerFlexContainer}>
                    <div className={styles.articleBody}>
                        <SponsorModule {...{ sponsorType: "sidebar", ...sponsorModuleProps }} />
                        <ArticleSocial {...social} />
                        {leadMedia && (
                            <LeadMediaModule {...leadMedia} showPinterest={true} />
                        )}
                        <ArticleContent {...articleContentProps} />
                        <SponsorModule {...{ sponsorType: "midway", ...sponsorModuleProps }} />
                        <RecentArticles primaryTopic={primaryTopic} />
                    </div>
                </div>
            </div>
            {FEATURE_FLAG_NEWSLETTER_MODAL && <EmailCapture {...article} />}
        </article>
    );
};
